import {Card, css, styled} from '@mui/material';
import {StyledCardProps} from './types';

export const StyledCard = styled(Card)<StyledCardProps>`
	padding: 16px;
	border-radius: 8px;

	${({$customBorderColor}) =>
		$customBorderColor &&
		css`
			border-bottom: 4px solid ${$customBorderColor};
		`}
`;
